module.exports = __webpack_public_path__ + "static/media/caravan.111e60aa.svg";